<rk-mobile-close-button class="fixed z-10" (click)="exitPanel()"></rk-mobile-close-button>
@if (playlist$ | async; as playlist) {
  <div class="p-5">
    <div class="line" (click)="editPlaylist(playlist)">
      <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
    </div>
    <div class="line delete" (click)="deletePlaylist(playlist)">
      <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
    </div>
  </div>
}
